import { createTheme, SegmentedControl } from '@mantine/core';
import { palette } from './palette';

// Радиусы/тени берём из существующих токенов (--box-container-radius, --shadow-lvl*).
// Радиус-шкалы как ramp в _tokens.scss нет — задаём здесь явную px-шкалу (позже можно
// вынести в tokens.scss). defaultRadius:'sm' (=8px) совпадает с фолбэком atoms/MaskedTimeInput/TimeColumns.scss
// (var(--mantine-radius-default, 8px)).
export const mantineTheme = createTheme({
    fontFamily: 'var(--font-family)', // токен из styles/_fonts.scss
    // Типографика Mantine сажается на нашу шкалу (styles/typography.scss).
    // До этого шкал было две: рукописный SCSS жил на 11–14px, а любой
    // <Text> без пропа и всё внутреннее устройство мантиновских компонентов —
    // на дефолтных xs 12 / sm 14 / md 16. Через var(--fz-*) источник остаётся
    // один, и --mantine-font-size-* становится законным способом сослаться
    // на шкалу из .scss.
    fontSizes: {
        xs: 'var(--fz-11)',
        sm: 'var(--fz-13)',
        md: 'var(--fz-14)',
        lg: 'var(--fz-16)',
        xl: 'var(--fz-18)',
    },
    // --mantine-line-height (= lineHeights.md) должен совпадать с базой body.
    lineHeights: {
        xs: 'var(--lh-ui)',
        sm: 'var(--lh-ui)',
        md: 'var(--lh-ui)',
        lg: 'var(--lh-text)',
        xl: 'var(--lh-text)',
    },
    // Заголовки набираются весом 600 — так их уже несколько лет пишет свежая
    // вёрстка (развилка Р7 в docs/typography-scale/PLAN.md).
    headings: {
        fontWeight: 'var(--fw-600)',
        sizes: {
            h1: { fontSize: 'var(--fz-28)', lineHeight: 'var(--lh-tight)' },
            h2: { fontSize: 'var(--fz-24)', lineHeight: 'var(--lh-tight)' },
            h3: { fontSize: 'var(--fz-20)', lineHeight: 'var(--lh-tight)' },
            h4: { fontSize: 'var(--fz-18)', lineHeight: 'var(--lh-ui)' },
            h5: { fontSize: 'var(--fz-16)', lineHeight: 'var(--lh-ui)' },
            h6: { fontSize: 'var(--fz-14)', lineHeight: 'var(--lh-ui)' },
        },
    },
    primaryColor: 'primary',
    primaryShade: 5, // main у всех семейств на idx5
    // «Бумага»: #fff в светлой, #26282c в тёмной; не входит в neutral-тюпл. Через неё же
    // Mantine красит текст на filled-заливке (--mantine-primary-color-contrast =
    // --mantine-color-white): в тёмной теме -main-ступени светлеют, и белый на них
    // не проходит AA (#fff на #379cff = 2.85), а цвет поверхности проходит (5.18) —
    // см. --text-on-accent в semantic.scss. theme.autoContrast НЕ включаем: светлоту
    // var()-палитры он посчитать не может (инертен), а на встроенных hex-цветах Mantine
    // (UserAvatar color="blue" и т. п.) перекрашивает белые инициалы в чёрные.
    white: 'var(--neutral-00)',
    black: 'var(--neutral-90)',
    colors: palette,
    defaultRadius: 'sm',
    radius: { xs: '4px', sm: '8px', md: '12px', lg: '16px', xl: 'var(--box-container-radius)' },
    shadows: {
        xs: 'var(--shadow-lvl1)',
        sm: 'var(--shadow-lvl2)',
        md: 'var(--shadow-lvl3)',
        lg: 'var(--shadow-lvl4)',
        xl: 'var(--shadow-lvl5)',
    },
    // На каждой волне сюда добавляем Component.extend({ defaultProps, classNames }).
    components: {
        // Сегментный контрол: фирменный вид всех вхождений (паритет с легаси-атомом
        // Segment, удалённым в Волне 2) — пилюля neutral-20, белый активный сегмент
        // с тенью. Стили — styles/_mantineFields.scss (.rf-segmented).
        SegmentedControl: SegmentedControl.extend({
            defaultProps: { radius: 20 },
            classNames: { root: 'rf-segmented' },
        }),
    },
});
